export interface QuickBooksWarning<T extends string> {
  type: T;
  args?: Record<string, unknown>;
}

export const hasBlockingQuickBooksWarnings = <T extends string>(
  warnings: QuickBooksWarning<T>[] | undefined
): boolean => !!warnings && warnings.length > 0;
